import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=735aac25"
import script from "./Blank.vue?vue&type=script&lang=js"
export * from "./Blank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('735aac25')) {
      api.createRecord('735aac25', component.options)
    } else {
      api.reload('735aac25', component.options)
    }
    module.hot.accept("./Blank.vue?vue&type=template&id=735aac25", function () {
      api.rerender('735aac25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/Blank.vue"
export default component.exports